import { Component, OnInit } from '@angular/core';
import * as fromStore from '@app/core/store';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {
  error$ = this.store.select( fromStore.selectAppError);
  constructor(private store: Store<fromStore.State>) { }

  ngOnInit() {
  }

  onBack() {
    this.store.dispatch(new fromStore.Back());
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/error-page/error-page.component.ts